// Modules
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import browserHistory from 'react-router/lib/browserHistory';

// Helpers
import appendLocale from '../../helpers/appendLocale';
import getUserLogoUrl from '../../utils/getUserLogoUrl';

// Styles
import * as styles from './CompanyRealtors.scss';

const CompanyRealtors = props => {
  const renderRealtor = (item, idx) => {
    const { name, image, id, is_staff } = item;
    const handleClick = () => is_staff && browserHistory.push(appendLocale(props.locale, `/staff/${id}`));

    return (
      <div
        key={`${image}_${idx}`}
        className={cx(styles.realtor, {
          [styles.staff]: is_staff
        })}
        onClick={handleClick}
      >
        <div className={styles.realtorImage}>
          <img src={getUserLogoUrl(image)} alt="" />
        </div>
        <span>{name}</span>
      </div>
    );
  };

  const renderRealtors = () => props.realtors && props.realtors.map(renderRealtor);
  const renderFirstRealtors = () => props.realtors && renderRealtor(props.realtors[0]);

  return (
    <div className={styles.realtorsBlock}>
      {props.isAdvanced
        ? renderRealtors()
        : renderFirstRealtors()
      }
    </div>
  );
};

CompanyRealtors.propTypes = {
  realtors: PropTypes.array,
  locale: PropTypes.string,
  isAdvanced: PropTypes.bool
};

export default CompanyRealtors;
